import React, { useEffect, useState } from 'react';
import { Check, Shield, X, Star, ChevronDown, Clock, BookOpen, Lock, AlertCircle } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
import { PurchasePopup } from '../components/PurchasePopup';
import { TestimonialCard } from '../components/TestimonialCard';
// Image URLs
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/6qrrKJBNLbZo3x9zPgBFbW/PROYECTOS_Anuales_(5).png';
const BONUS_1_IMAGE = 'https://cdn.magicpatterns.com/uploads/innVMTkTCmJ4eQoJahCdgb/31.png';
const BONUS_2_IMAGE = 'https://cdn.magicpatterns.com/uploads/4HkkRvsjcK6FDMmMdQETVT/32.png';
const BONUS_3_IMAGE = 'https://cdn.magicpatterns.com/uploads/2qUaHoCzFsrqL3YNug2J72/33.png';
function CountdownTimer() {
  const [time, setTime] = useState({
    minutes: 14,
    seconds: 54
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prevTime => {
        if (prevTime.seconds > 0) {
          return {
            ...prevTime,
            seconds: prevTime.seconds - 1
          };
        } else if (prevTime.minutes > 0) {
          return {
            minutes: prevTime.minutes - 1,
            seconds: 59
          };
        }
        return prevTime;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-red-600 text-white py-1.5 px-4 text-center font-medium text-[10px] md:text-xs sticky top-0 z-40 shadow-md" data-id="element-21">
      <div className="max-w-6xl mx-auto flex items-center justify-center gap-2" data-id="element-22">
        <Clock className="w-3 h-3 animate-pulse" data-id="element-23" />
        <span data-id="element-24">
          OFERTA EXPIRA EN: {String(time.minutes).padStart(2, '0')}:
          {String(time.seconds).padStart(2, '0')} | 🔥 SOLO QUEDAN 3 CUPOS
        </span>
      </div>
    </div>;
}
export function LandingPage() {
  const checkoutUrl = 'https://checkout16.recursospro.shop/cart/45212460810284:1';
  const testimonials = [{
    name: 'María González',
    role: 'Profesora de Matemática',
    location: 'Buenos Aires',
    content: 'Antes pasaba horas buscando material. Ahora entro a clase con todo listo.'
  }, {
    name: 'Carlos Ramírez',
    role: 'Docente de Secundaria',
    location: 'Madrid',
    content: 'Me ahorró muchísimo tiempo. En minutos tengo la clase armada.'
  }, {
    name: 'Ana Martínez',
    role: 'Profesora de Matemática',
    location: 'México',
    content: 'Mis alumnos entienden más y yo explico con más seguridad.'
  }, {
    name: 'José López',
    role: 'Profesor de Bachillerato',
    location: 'Bogotá',
    content: 'En 20 años de docencia, es el recurso más completo que usé.'
  }, {
    name: 'Laura Fernández',
    role: 'Profesora ESO',
    location: 'Santiago',
    content: 'No es teoría vacía. Es práctica real que funciona en el aula.'
  }];
  const faqs = [{
    q: '¿Es material digital?',
    a: 'Sí. Acceso y descarga inmediata.'
  }, {
    q: '¿Sirve para cualquier nivel educativo?',
    a: 'Sí. Cubre de 1° a 6° año (Secundaria / Bachillerato / ESO).'
  }, {
    q: '¿Funciona para clases presenciales y online?',
    a: 'Sí, es totalmente adaptable.'
  }, {
    q: '¿Necesito experiencia previa?',
    a: 'No. Todo está explicado paso a paso.'
  }];
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-25">
      <PurchasePopup data-id="element-26" />
      <CountdownTimer data-id="element-27" />

      {/* Hero Section */}
      <header className="bg-white text-gray-900 pt-8 pb-12 px-4 text-center" data-id="element-28">
        <div className="max-w-4xl mx-auto" data-id="element-29">
          <p className="text-blue-600 font-bold text-lg md:text-xl mb-4 tracking-wide uppercase" data-id="element-30">
            📐 Para docentes de Matemática
          </p>

          <h1 className="text-4xl md:text-6xl font-extrabold mb-4 leading-tight text-gray-900" data-id="element-31">
            MegaPack Matemática Lista
          </h1>

          <h2 className="text-xl md:text-2xl text-gray-700 mb-6 font-medium max-w-3xl mx-auto" data-id="element-32">
            Todo el material de Matemática que necesitás, listo para usar.
          </h2>

          <p className="text-lg text-gray-600 mb-4 max-w-2xl mx-auto leading-relaxed" data-id="element-33">
            Clases claras, ordenadas y sin pasar horas planificando. Dejá de
            empezar desde cero cada semana.
          </p>

          <div className="mb-4" data-id="element-34">
            <a href={checkoutUrl} data-id="element-35">
              <img src={MAIN_IMAGE} alt="MegaPack Matemática LISTA" className="mx-auto max-w-full w-64 md:w-96 drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-36" />
            </a>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-37">
            <CTAButton text="👉 SÍ, QUIERO ACCEDER AHORA" className="text-sm md:text-base px-6 py-3 w-full md:w-auto" scrollToPurchase={true} data-id="element-38" />

            <div className="flex items-center gap-2 text-sm text-gray-500 font-medium" data-id="element-39">
              <Shield className="w-4 h-4 text-green-500" data-id="element-40" />
              <span data-id="element-41">Garantía de satisfacción de 7 días</span>
            </div>
          </div>
        </div>
      </header>

      {/* Problem Section */}
      <section className="py-16 px-4 bg-blue-50" data-id="element-42">
        <div className="max-w-3xl mx-auto" data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10 leading-tight" data-id="element-44">
            Si enseñás Matemática, dejame hacerte una pregunta honesta
          </h2>

          <div className="bg-white rounded-xl p-8 md:p-10 shadow-lg mb-10 border-t-4 border-red-500" data-id="element-45">
            <h3 className="text-2xl md:text-3xl font-bold text-red-600 mb-6 text-center" data-id="element-46">
              ¿Te pasa que preparar la clase te cansa más que darla?
            </h3>

            <div className="space-y-4 text-lg text-gray-700" data-id="element-47">
              <p data-id="element-48">
                No porque no sepas Matemática. No porque no seas buen docente.
              </p>

              <p data-id="element-49">Sino porque cada clase parece empezar desde cero.</p>

              <p data-id="element-50">
                Buscar ejercicios. Pensar problemas que se entiendan. Armar
                actividades. Preparar evaluaciones. Ordenar material suelto.
              </p>

              <p className="font-bold text-gray-900 bg-red-50 p-4 rounded-lg border border-red-100" data-id="element-51">
                Y cuando finalmente entrás al aula… ya estás cansado/a.
              </p>
            </div>
          </div>

          <p className="text-2xl md:text-3xl font-bold text-center text-blue-600" data-id="element-52">
            Enseñar Matemática no debería sentirse así.
          </p>
        </div>
      </section>

      {/* Problem List */}
      <section className="py-16 px-4 bg-white" data-id="element-53">
        <div className="max-w-3xl mx-auto" data-id="element-54">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-55">
            El problema que nadie dice en voz alta
          </h2>

          <p className="text-lg text-gray-700 mb-8 text-center max-w-2xl mx-auto" data-id="element-56">
            Si sos docente de Matemática, esto seguramente te resulta familiar:
          </p>

          <div className="bg-gray-50 rounded-xl p-8 space-y-5 border border-gray-100" data-id="element-57">
            {['Pasás horas planificando cada semana', 'Tenés material, pero está desordenado', 'Buscás ejercicios en mil lugares distintos', 'Guardás PDFs que después no encontrás', 'Terminás improvisando más de lo que te gustaría'].map((item, idx) => <div key={idx} className="flex items-start gap-4" data-id="element-58">
                <div className="bg-red-100 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-59">
                  <X className="w-5 h-5 text-red-600" data-id="element-60" />
                </div>
                <span className="text-lg text-gray-800" data-id="element-61">{item}</span>
              </div>)}
          </div>

          <div className="mt-10 bg-yellow-50 border-l-8 border-yellow-400 p-8 rounded-r-lg shadow-sm" data-id="element-62">
            <p className="text-xl text-gray-800 italic text-center" data-id="element-63">
              Lo peor es esa sensación constante de:
              <br data-id="element-64" />
              <strong className="text-2xl block mt-2 not-italic" data-id="element-65">
                "Podría dar mejores clases… si tuviera todo el material listo."
              </strong>
            </p>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-20 px-4 bg-blue-600 text-white text-center relative overflow-hidden" data-id="element-66">
        {/* Background pattern */}
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-67"></div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-68">
          <h2 className="text-yellow-300 font-bold text-xl md:text-2xl mb-4 tracking-wider uppercase" data-id="element-69">
            ✅ LA SOLUCIÓN
          </h2>
          <h3 className="text-4xl md:text-6xl font-extrabold mb-8 drop-shadow-md" data-id="element-70">
            MegaPack Matemática Lista
          </h3>
          <p className="text-xl md:text-2xl mb-16 leading-relaxed max-w-3xl mx-auto text-blue-50" data-id="element-71">
            Un sistema completo de recursos de Matemática, organizado por año,
            diseñado para que dejes de improvisar y vuelvas a disfrutar enseñar.
          </p>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto text-lg" data-id="element-72">
            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 hover:bg-white/20 transition-colors" data-id="element-73">
              <div className="text-5xl mb-4" data-id="element-74">📂</div>
              <p className="font-bold text-xl" data-id="element-75">Abrís el material</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 hover:bg-white/20 transition-colors" data-id="element-76">
              <div className="text-5xl mb-4" data-id="element-77">👆</div>
              <p className="font-bold text-xl" data-id="element-78">Elegís el tema</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 hover:bg-white/20 transition-colors" data-id="element-79">
              <div className="text-5xl mb-4" data-id="element-80">✏️</div>
              <p className="font-bold text-xl" data-id="element-81">Lo aplicás en clase</p>
            </div>
          </div>

          <p className="text-2xl mt-12 font-bold text-white" data-id="element-82">
            Sin vueltas. Sin improvisar. Sin perder tiempo.
          </p>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-20 px-4 bg-white" data-id="element-83">
        <div className="max-w-5xl mx-auto" data-id="element-84">
          <h2 className="text-3xl md:text-5xl font-bold text-center text-gray-900 mb-16" data-id="element-85">
            📘 ¿Qué incluye exactamente el MegaPack?
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-86">
            {['6 cuadernillos completos (1° a 6° año)', 'Teoría clara explicada paso a paso', 'Ejercicios resueltos', 'Actividades prácticas', 'Evaluaciones y diagnósticos', 'Secuencias didácticas por unidad', 'Material visual', 'Planillas docentes'].map((item, idx) => <div key={idx} className="flex items-center gap-4 bg-blue-50 p-6 rounded-xl hover:shadow-md transition-shadow border border-blue-100" data-id="element-87">
                <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-88">
                  <Check className="w-6 h-6 text-green-600" data-id="element-89" />
                </div>
                <span className="text-lg text-gray-800 font-bold" data-id="element-90">{item}</span>
              </div>)}
          </div>

          <p className="text-center text-xl text-gray-700 mb-10 max-w-2xl mx-auto" data-id="element-91">
            Todo organizado para encontrar rápido lo que necesitás y cubrir todo
            el programa.
          </p>

          <div className="text-center" data-id="element-92">
            <CTAButton text="👉 ACCEDER CON DESCUENTO" className="text-xl px-12 py-5" scrollToPurchase={true} data-id="element-93" />
          </div>
        </div>
      </section>

      {/* Before vs After */}
      <section className="py-20 px-4 bg-gray-900 text-white" data-id="element-94">
        <div className="max-w-6xl mx-auto" data-id="element-95">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-16" data-id="element-96">
            Antes vs Después
          </h2>

          <div className="grid md:grid-cols-2 gap-10" data-id="element-97">
            {/* Before */}
            <div className="bg-red-900/20 p-8 md:p-10 rounded-2xl border-2 border-red-500/50 backdrop-blur-sm" data-id="element-98">
              <h3 className="text-2xl font-bold mb-8 text-red-400 flex items-center gap-3" data-id="element-99">
                <X className="w-8 h-8" data-id="element-100" />
                Antes del MegaPack
              </h3>
              <div className="space-y-6" data-id="element-101">
                {['Improvisación constante', 'Cansancio mental', 'Clases apuradas', 'Trabajo extra en casa', 'Estrés antes de cada clase'].map((item, idx) => <div key={idx} className="flex items-center gap-4" data-id="element-102">
                    <X className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-103" />
                    <span className="text-xl text-gray-300" data-id="element-104">{item}</span>
                  </div>)}
              </div>
            </div>

            {/* After */}
            <div className="bg-green-900/20 p-8 md:p-10 rounded-2xl border-2 border-green-500/50 backdrop-blur-sm relative overflow-hidden" data-id="element-105">
              <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-106">
                RECOMENDADO
              </div>
              <h3 className="text-2xl font-bold mb-8 text-green-400 flex items-center gap-3" data-id="element-107">
                <Check className="w-8 h-8" data-id="element-108" />
                Después del MegaPack{' '}
                <span className="text-yellow-300 ml-2 text-sm bg-yellow-900/50 px-2 py-1 rounded" data-id="element-109">
                  ¡Mejor!
                </span>
              </h3>
              <div className="space-y-6" data-id="element-110">
                {['Clases claras y organizadas', 'Material listo siempre', 'Más seguridad al explicar', 'Menos trabajo fuera del aula', 'Más tranquilidad para enseñar'].map((item, idx) => <div key={idx} className="flex items-center gap-4" data-id="element-111">
                    <Check className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-112" />
                    <span className="text-xl text-white font-medium" data-id="element-113">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-24 px-4 bg-blue-50" data-id="element-114">
        <div className="max-w-6xl mx-auto" data-id="element-115">
          <div className="text-center mb-16" data-id="element-116">
            <h2 className="text-3xl md:text-5xl font-bold mb-4 text-gray-900" data-id="element-117">
              🎁 Regalos especiales
            </h2>
            <p className="text-2xl font-bold text-blue-600 mb-2 uppercase tracking-wide" data-id="element-118">
              BONOS INCLUIDOS HOY
            </p>
            <p className="text-lg text-gray-600" data-id="element-119">(Sin costo adicional)</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-120">
            {/* Bonus 1 */}
            <a href={checkoutUrl} className="group h-full" data-id="element-121">
              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 h-full flex flex-col border border-gray-100" data-id="element-122">
                <div className="relative mb-6" data-id="element-123">
                  <img src={BONUS_1_IMAGE} alt="Kit Premium de Evaluaciones" className="w-full rounded-xl transform group-hover:scale-105 transition-transform duration-300" data-id="element-124" />
                  <div className="absolute -top-4 -right-4 bg-green-500 text-white text-sm font-bold px-4 py-2 rounded-full shadow-lg animate-bounce" data-id="element-125">
                    GRATIS HOY
                  </div>
                </div>
                <div className="mb-4" data-id="element-126">
                  <p className="text-gray-400 line-through text-sm" data-id="element-127">
                    Valor: $19
                  </p>
                  <p className="text-green-600 font-bold text-xl" data-id="element-128">
                    HOY: GRATIS
                  </p>
                </div>
                <h3 className="font-bold text-xl text-gray-900 mb-3 leading-tight" data-id="element-129">
                  🎁 Bono #1 – Kit Premium de Evaluaciones
                </h3>
                <p className="text-gray-600" data-id="element-130">
                  +50 evaluaciones listas con criterios de corrección.
                </p>
              </div>
            </a>

            {/* Bonus 2 */}
            <a href={checkoutUrl} className="group h-full" data-id="element-131">
              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 h-full flex flex-col border border-gray-100" data-id="element-132">
                <div className="relative mb-6" data-id="element-133">
                  <img src={BONUS_2_IMAGE} alt="Banco de Juegos" className="w-full rounded-xl transform group-hover:scale-105 transition-transform duration-300" data-id="element-134" />
                  <div className="absolute -top-4 -right-4 bg-green-500 text-white text-sm font-bold px-4 py-2 rounded-full shadow-lg animate-bounce" data-id="element-135">
                    GRATIS HOY
                  </div>
                </div>
                <div className="mb-4" data-id="element-136">
                  <p className="text-gray-400 line-through text-sm" data-id="element-137">
                    Valor: $15
                  </p>
                  <p className="text-green-600 font-bold text-xl" data-id="element-138">
                    HOY: GRATIS
                  </p>
                </div>
                <h3 className="font-bold text-xl text-gray-900 mb-3 leading-tight" data-id="element-139">
                  🎁 Bono #2 – Banco de Juegos y Actividades
                </h3>
                <p className="text-gray-600" data-id="element-140">
                  Más de 30 recursos lúdicos para motivar tus clases.
                </p>
              </div>
            </a>

            {/* Bonus 3 */}
            <a href={checkoutUrl} className="group h-full" data-id="element-141">
              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 h-full flex flex-col border border-gray-100" data-id="element-142">
                <div className="relative mb-6" data-id="element-143">
                  <img src={BONUS_3_IMAGE} alt="Plantillas Profesionales" className="w-full rounded-xl transform group-hover:scale-105 transition-transform duration-300" data-id="element-144" />
                  <div className="absolute -top-4 -right-4 bg-green-500 text-white text-sm font-bold px-4 py-2 rounded-full shadow-lg animate-bounce" data-id="element-145">
                    GRATIS HOY
                  </div>
                </div>
                <div className="mb-4" data-id="element-146">
                  <p className="text-gray-400 line-through text-sm" data-id="element-147">
                    Valor: $12
                  </p>
                  <p className="text-green-600 font-bold text-xl" data-id="element-148">
                    HOY: GRATIS
                  </p>
                </div>
                <h3 className="font-bold text-xl text-gray-900 mb-3 leading-tight" data-id="element-149">
                  🎁 Bono #3 – Plantillas Profesionales de Planificación
                </h3>
                <p className="text-gray-600" data-id="element-150">
                  Modelos semanales y mensuales para organizar todo el año.
                </p>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="purchase-section" className="py-24 px-4 bg-white scroll-mt-20" data-id="element-151">
        <div className="max-w-4xl mx-auto text-center" data-id="element-152">
          <div className="bg-yellow-100 border-2 border-yellow-400 rounded-lg px-6 py-3 mb-10 inline-block shadow-sm" data-id="element-153">
            <p className="text-xl font-bold text-gray-900 flex items-center gap-2" data-id="element-154">
              <Clock className="w-5 h-5 text-yellow-600" data-id="element-155" />⏰ Oferta por tiempo
              limitado
            </p>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-156">
            Accedé a MegaPack Matemática Lista
          </h2>
          <p className="text-xl md:text-2xl text-blue-600 font-bold mb-12" data-id="element-157">
            + los 3 Bonos de regalo
          </p>

          <div className="bg-gradient-to-b from-blue-50 to-white rounded-3xl p-8 md:p-12 max-w-2xl mx-auto mb-12 shadow-2xl border border-blue-100 relative overflow-hidden" data-id="element-158">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-blue-400 via-blue-600 to-blue-400" data-id="element-159"></div>

            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-left flex items-center gap-2" data-id="element-160">
              <BookOpen className="w-6 h-6 text-blue-600" data-id="element-161" />
              📦 Lo que vas a recibir hoy:
            </h3>

            <div className="text-left space-y-4 mb-10" data-id="element-162">
              {['6 cuadernillos de Matemática (1° a 6° año)', 'Bono #1: Kit Premium de Evaluaciones', 'Bono #2: Banco de Juegos y Actividades', 'Bono #3: Plantillas Profesionales de Planificación', 'Teoría clara + ejercicios resueltos', 'Actividades prácticas y material visual'].map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-163">
                  <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-164">
                    <Check className="w-4 h-4 text-green-600 flex-shrink-0" data-id="element-165" />
                  </div>
                  <span className="text-gray-800 font-medium" data-id="element-166">{item}</span>
                </div>)}
            </div>

            <div className="border-t-2 border-dashed border-gray-200 pt-8 mb-8" data-id="element-167">
              <p className="text-red-400 line-through text-2xl font-bold mb-2" data-id="element-168">
                Precio regular: $49.990 ARS
              </p>
              <div className="mb-6" data-id="element-169">
                <p className="text-gray-600 font-semibold text-lg mb-1 uppercase tracking-wider" data-id="element-170">
                  HOY SOLO:
                </p>
                <p className="text-6xl md:text-7xl font-extrabold text-blue-600 tracking-tight" data-id="element-171">
                  $17.990 ARS
                </p>
              </div>
              <p className="text-sm text-gray-500 bg-gray-50 inline-block px-3 py-1 rounded-full" data-id="element-172">
                *Precio en pesos argentinos
              </p>
            </div>

            <div className="grid grid-cols-2 gap-3 mb-10 text-sm" data-id="element-173">
              {['✔ Acceso inmediato', '✔ Un solo pago', '✔ Descarga digital', '✔ Acceso de por vida'].map(item => <div key={item} className="bg-white border border-gray-100 p-2 rounded-md font-medium text-gray-600 text-center" data-id="element-174">
                  {item}
                </div>)}
            </div>

            <CTAButton text="👉 OBTENER MI MEGAPACK HOY" fullWidth className="text-xl py-6 mb-6 shadow-xl hover:shadow-2xl" data-id="element-175" />

            <div className="mt-8 bg-blue-50/50 p-6 rounded-xl border border-blue-100" data-id="element-176">
              <div className="flex items-start md:items-center justify-center gap-4" data-id="element-177">
                <Shield className="w-10 h-10 text-blue-600 flex-shrink-0" data-id="element-178" />
                <div className="text-left" data-id="element-179">
                  <p className="font-bold text-gray-900 text-lg" data-id="element-180">
                    Garantía sin riesgo
                  </p>
                  <p className="text-sm text-gray-600 leading-snug" data-id="element-181">
                    Probalo durante 7 días. Si no es para vos, te devolvemos el
                    100% del dinero.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 px-4 bg-blue-50" data-id="element-182">
        <div className="max-w-6xl mx-auto" data-id="element-183">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16" data-id="element-184">
            Lo que dicen otros docentes
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-185">
            {testimonials.map((t, i) => <TestimonialCard key={i} name={t.name} role={t.role} location={t.location} content={t.content} data-id="element-186" />)}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 px-4 bg-white" data-id="element-187">
        <div className="max-w-3xl mx-auto" data-id="element-188">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16" data-id="element-189">
            Preguntas frecuentes
          </h2>
          <div className="space-y-6" data-id="element-190">
            {faqs.map((faq, idx) => <div key={idx} className="bg-blue-50 rounded-xl p-8 hover:bg-blue-100/50 transition-colors" data-id="element-191">
                <h3 className="font-bold text-xl text-gray-900 mb-3 flex items-start gap-3" data-id="element-192">
                  <span className="text-blue-600" data-id="element-193">Q:</span> {faq.q}
                </h3>
                <p className="text-gray-700 text-lg pl-8" data-id="element-194">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-24 px-4 bg-gray-900 text-white text-center relative overflow-hidden" data-id="element-195">
        <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-196"></div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-197">
          <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-198">
            Enseñar Matemática puede ser más simple
          </h2>
          <p className="text-xl md:text-2xl mb-12 text-gray-300 max-w-2xl mx-auto" data-id="element-199">
            No necesitás más material. Necesitás un sistema que te sostenga todo
            el año.
          </p>
          <CTAButton text="👉 Accedé ahora al MegaPack Matemática Lista" className="text-xl px-12 py-6 shadow-2xl shadow-green-900/50" scrollToPurchase={true} data-id="element-200" />
        </div>
      </section>

      <footer className="bg-black text-gray-500 py-12 px-4 text-center text-sm border-t border-gray-800" data-id="element-201">
        <div className="max-w-6xl mx-auto" data-id="element-202">
          <p className="mb-4 text-lg font-semibold text-gray-400" data-id="element-203">
            MegaPack Matemática Lista
          </p>
          <p data-id="element-204">&copy; 2026 Todos los derechos reservados.</p>
          <div className="mt-6 flex justify-center gap-6" data-id="element-205">
            <span className="hover:text-gray-300 cursor-pointer transition-colors" data-id="element-206">
              Privacidad
            </span>
            <span className="hover:text-gray-300 cursor-pointer transition-colors" data-id="element-207">
              Términos y Condiciones
            </span>
            <span className="hover:text-gray-300 cursor-pointer transition-colors" data-id="element-208">
              Contacto
            </span>
          </div>
        </div>
      </footer>
    </div>;
}